
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","data-name":"Rectangle 1278","fill":"none"}}),_c('path',{attrs:{"d":"M9.354 20.707l-1.415-1.414L15.232 12 7.939 4.707l1.415-1.414L18.061 12z","data-name":"Path 1259"}})])
          )
        }
      }
    